import { render, staticRenderFns } from "./CreateOrderModal.vue?vue&type=template&id=20613a2b"
import script from "./CreateOrderModal.vue?vue&type=script&lang=js"
export * from "./CreateOrderModal.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderModal.vue?vue&type=style&index=0&id=20613a2b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20613a2b')) {
      api.createRecord('20613a2b', component.options)
    } else {
      api.reload('20613a2b', component.options)
    }
    module.hot.accept("./CreateOrderModal.vue?vue&type=template&id=20613a2b", function () {
      api.rerender('20613a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentOrder/PaymentOrder/CreateOrderModal.vue"
export default component.exports